import { render, staticRenderFns } from "./ChangeContentNumeric.vue?vue&type=template&id=2df36c06&scoped=true"
import script from "./ChangeContentNumeric.vue?vue&type=script&lang=js"
export * from "./ChangeContentNumeric.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df36c06",
  null
  
)

export default component.exports